module.exports = __webpack_public_path__ + "img/search-black.f2816c3c.svg";